import React, { useEffect, useState } from 'react'
import Layout from "../../components/layout"
import { HeaderWrapper, ContentWrapper } from './style'
import Input from '../../components/Input'
import CustomerProfile from './CustomerProfile'
import Pagination from '../../components/pagination';
import {getCustomersByGroupsApi, getCustomersGroupsApi } from '../../api/index'
import { useNavigate } from 'react-router-dom'
import {countryCode, getKeyByValue} from '../../utils/country';
import { useDebounce } from 'use-debounce'

const Index = () => {
  const navigate = useNavigate();
  const [tab, setTab] = useState("Industry");
  const [tabId, setTabId] = useState(null);
  const [openProfile, setOpenProfile] = useState(false)
  const [businessData, setBusinessData] = useState([])
  const [currentPage, setCurrentPage] = useState(0);
  const [search, setSearch] = useState("")
  const [debouncedSearch] = useDebounce(search, 300);
  // const businessData = [
  //   {
  //     name:'Betty King',
  //     email:'bettyking@gmail.com',
  //     position:'Position Name',
  //     address:"132, My Street, Kingston, New York 12401.",
  //     counrty:"USA",
  //     industry:"Industry Name",
  //     academic:"Academic Name",
  //   },
  //   {
  //     name:'Betty King',
  //     email:'bettyking@gmail.com',
  //     position:'Position Name',
  //     address:"132, My Street, Kingston, New York 12401.",
  //     counrty:"USA",
  //     industry:"Industry Name",
  //     academic:"Academic Name",
  //   },
  //   {
  //     name:'Betty King',
  //     email:'bettyking@gmail.com',
  //     position:'Position Name',
  //     address:"132, My Street, Kingston, New York 12401.",
  //     counrty:"USA",
  //     industry:"Industry Name",
  //     academic:"Academic Name",
  //   },
  //   {
  //     name:'Betty King',
  //     email:'bettyking@gmail.com',
  //     position:'Position Name',
  //     address:"132, My Street, Kingston, New York 12401.",
  //     counrty:"USA",
  //     industry:"Industry Name",
  //     academic:"Academic Name",
  //   },
  //   {
  //     name:'Betty King',
  //     email:'bettyking@gmail.com',
  //     position:'Position Name',
  //     address:"132, My Street, Kingston, New York 12401.",
  //     counrty:"USA",
  //     industry:"Industry Name",
  //     academic:"Academic Name",
  //   },
  //   {
  //     name:'Betty King',
  //     email:'bettyking@gmail.com',
  //     position:'Position Name',
  //     address:"132, My Street, Kingston, New York 12401.",
  //     counrty:"USA",
  //     industry:"Industry Name",
  //     academic:"Academic Name",
  //   },
  //   {
  //     name:'Betty King',
  //     email:'bettyking@gmail.com',
  //     position:'Position Name',
  //     address:"132, My Street, Kingston, New York 12401.",
  //     counrty:"USA",
  //     industry:"Industry Name",
  //     academic:"Academic Name",
  //   },
  //   {
  //     name:'Betty King',
  //     email:'bettyking@gmail.com',
  //     position:'Position Name',
  //     address:"132, My Street, Kingston, New York 12401.",
  //     counrty:"USA",
  //     industry:"Industry Name",
  //     academic:"Academic Name",
  //   },
  //   {
  //     name:'Betty King',
  //     email:'bettyking@gmail.com',
  //     position:'Position Name',
  //     address:"132, My Street, Kingston, New York 12401.",
  //     counrty:"USA",
  //     industry:"Industry Name",
  //     academic:"Academic Name",
  //   },
  //   {
  //     name:'Betty King',
  //     email:'bettyking@gmail.com',
  //     position:'Position Name',
  //     address:"132, My Street, Kingston, New York 12401.",
  //     counrty:"USA",
  //     industry:"Industry Name",
  //     academic:"Academic Name",
  //   }

  // ];

  useEffect(() => {
    setCurrentPage(0)
  }, [tab])


  useEffect(() => {
    getCustomersGroupsApi(tab).then((res) => {
      if (res && res.data) {
        setTabId(res.data?.customer_groups[0]?.id)
       getCustomersByGroupsApi(res.data?.customer_groups[0]?.id, 10, currentPage * 10, search, tab ).then((res) => {
        if (res && res.data) {
          setBusinessData(res.data)
        }
       })
      }
    })
  }, [tab])


  useEffect(() => {
    if(tabId){
    getCustomersByGroupsApi(tabId, 10, currentPage * 10, search, tab).then((res) => {
      if (res && res.data) {
        setBusinessData(res.data)
      }
    })
  }
  }, [currentPage, debouncedSearch, tabId])








  // if (openProfile) {
  //   return <CustomerProfile setOpenProfile={setOpenProfile}  />
  // }

  return (
    <Layout>
      <HeaderWrapper>
        <div className="header-title"><span className='sub-title'>Customers</span>{businessData?.count}</div>
        <div className="header-search-container">
          <Input type="text" search style={{ height: '40px', paddingLeft: '30px' }} placeholder={'Search'} onChange={(e) => setSearch(e.target.value)} />
          <div className="tab-container">
            <button style={{ borderTopLeftRadius: '12px', borderBottomLeftRadius: '12px' }} className={tab === "Industry" && 'tab-active'} onClick={() => setTab("Industry")}>Industry</button>
            <button style={{ borderTopRightRadius: '12px', borderBottomRightRadius: '12px' }} className={tab === "Academic" && 'tab-active'} onClick={() => setTab("Academic")}>Academic</button>
          </div>
        </div>
      </HeaderWrapper>
      <ContentWrapper>
        {businessData && businessData?.customers?.length > 0 ? <>
          <table className={"mainTable"}>
            <thead>
              <tr>
                <th>Name </th>
                <th>Email</th>
                <th>Position</th>
                <th>Address</th>
                <th>Country</th>
                <th>{tab === 'Academic' ? 'Institute' : tab}</th>
                <th>View</th>
              </tr>
            </thead>
            <tbody>
              {businessData?.customers?.map((business) => {
                return (
                  <tr
                    key={business?.id}
                  >
                    <td>
                      {business?.first_name ? business?.first_name + " " + business?.last_name : "-"}
                    </td>
                    <td>
                      {business?.email ? business?.email : "-"}
                    </td>
                    <td>
                      {business?.position ? business?.position : "-"}
                    </td>
                    <td style={{width:'200px'}}>
                      {business?.shipping_addresses.find((item) => item?.metadata?.type === 'billing' && item?.metadata?.is_primary) ? business?.shipping_addresses?.find((item) => item?.metadata?.type === 'billing' && item?.metadata?.is_primary)?.address_1 + " " + business?.shipping_addresses?.find((item) => item?.metadata?.type === 'billing' && item?.metadata?.is_primary)?.city + ", " + business?.shipping_addresses?.find((item) => item?.metadata?.type === 'billing' && item?.metadata?.is_primary)?.postal_code : "-"}
                    </td>
                    <td>
                      {business?.billing_address ? getKeyByValue(countryCode, business?.billing_address?.country_code?.toUpperCase()) : "-"}
                    </td>
                    <td style={{width:'180px'}}>{business?.billing_address ?  business?.billing_address?.company : "-"}</td>
                    <td style={{ cursor: "pointer" }}>
                      <span style={{ display: 'flex', gap: '30px', alignItems: 'center', justifyContent: 'flex-end' }}>
                        <button style={{ fontSize: '16px', color: '#6c6a73' }} onClick={() => navigate(`/customers/${business?.id}`)}><i class="fal fa-eye"></i></button>
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
         {businessData?.count / businessData?.limit > 1 && <Pagination total={businessData?.count / businessData.limit} setCurrentPage={setCurrentPage} currentPage={currentPage}  /> }
        </>
          : <div className='no-orders'>
            <span className='icon'>
              <i class="far fa-boxes"></i>
            </span>
            <p>No Customers Yet.</p>
          </div>
        }
      </ContentWrapper>
    </Layout>
  )
}

export default Index